module.exports = __webpack_public_path__ + "img/img-turfy-umajo-3.90fa4edb.png";